export default {
    state: {
        access: {
            showModal: false,
        },
        clients: {
            types: {
                buyer: 0,
                seller: 1,
                new: 2,
            },
        },
        currencies: [
            { id: 1, name: "uah", symbol: "₴" },
            { id: 2, name: "usd", symbol: "$" },
            { id: 3, name: "eur", symbol: "€" },
        ],
        existence: [
            { id: 0, name: "notAvailable" },
            { id: 1, name: "inStock" },
            { id: 2, name: "lowLevel" },
        ],
        drawer: null,
        filters: {
            general: {
                actionSubstance: {
                    systemName: "actionSubstance",
                    type: "autocompleteMultiple",
                },
                actionType: {
                    systemName: "actionType",
                    type: "autocompleteMultiple",
                },
                archive: {
                    systemName: "is_archive",
                    type: "switch",
                },
                article: {
                    systemName: "article",
                    type: "autocomplete",
                },
                awesomeEnum: {
                    systemName: "awesomeEnum",
                    type: "autocomplete",
                },
                bioDrug: {
                    systemName: "bioDrug",
                    type: "autocompleteMultiple",
                },
                buyer: {
                    systemName: "buyer",
                    type: "autocomplete",
                },
                category: {
                    systemName: "category",
                    type: "autocomplete",
                },
                categoryID: {
                    systemName: "category_id",
                    type: "autocompleteMultiple",
                },
                categoryCode: {
                    systemName: "category_code",
                    type: "autocompleteMultiple",
                },
                categoryDeleted: {
                    systemName: "category_deleted",
                    type: "switch",
                },
                categoryStatus: {
                    systemName: "category_status",
                    type: "autocompleteMultiple",
                },
                categoryWithoutProducts: {
                    systemName: "category_without_products",
                    type: "switch",
                },
                chemicalClass: {
                    systemName: "chemicalClass",
                    type: "autocompleteMultiple",
                },
                chemicalComposition: {
                    systemName: "chemicalComposition",
                    type: "autocompleteMultiple",
                },
                composition: {
                    systemName: "composition",
                    type: "autocompleteMultiple",
                },
                creation: {
                    systemName: "creation",
                    type: "range",
                },
                culture: {
                    systemName: "culture",
                    type: "autocompleteMultiple",
                },
                company: {
                    systemName: "company",
                    type: "autocomplete",
                },
                consideration: {
                    systemName: "consideration",
                    type: "switch",
                },
                delivery: {
                    systemName: "delivery",
                    type: "switch",
                },
                diseaseTolerance: {
                    systemName: "diseaseTolerance",
                    type: "autocompleteMultiple",
                },
                doubleEar: {
                    systemName: "doubleEar",
                    type: "autocompleteMultiple",
                },
                droughtProductivity: {
                    systemName: "droughtProductivity",
                    type: "autocompleteMultiple",
                },
                droughtTolerance: {
                    systemName: "droughtTolerance",
                    type: "autocompleteMultiple",
                },
                enumAttributeID: {
                    systemName: "enum_attribute_id",
                    type: "autocompleteMultiple",
                },
                enumAttributeValueID: {
                    systemName: "enum_attribute_value_id",
                    type: "autocompleteMultiple",
                },
                existence: {
                    systemName: "existence",
                    type: "autocomplete",
                },
                exposureType: {
                    systemName: "exposureType",
                    type: "autocompleteMultiple",
                },
                fao: {
                    systemName: "fao",
                    type: "autocompleteMultiple",
                },
                gmo: {
                    systemName: "gmo",
                    type: "autocomplete",
                },
                growTechnology: {
                    systemName: "growTechnology",
                    type: "autocompleteMultiple",
                },
                harmfulObject: {
                    systemName: "harmfulObject",
                    type: "autocompleteMultiple",
                },
                herbicideType: {
                    systemName: "herbicideType",
                    type: "autocompleteMultiple",
                },
                highOleic: {
                    systemName: "highOleic",
                    type: "autocomplete",
                },
                inProcess: {
                    systemName: "in_process",
                    type: "switch",
                },
                insecticideType: {
                    systemName: "insecticideType",
                    type: "autocompleteMultiple",
                },
                lodgingResistance: {
                    systemName: "lodgingResistance",
                    type: "autocompleteMultiple",
                },
                manufacturer: {
                    systemName: "manufacturer",
                    type: "autocompleteMultiple",
                },
                maxPrice: {
                    systemName: "maxPrice",
                    type: "range",
                },
                minPrice: {
                    systemName: "minPrice",
                    type: "range",
                },
                moistureLoss: {
                    systemName: "moistureLoss",
                    type: "autocompleteMultiple",
                },
                notill: {
                    systemName: "notill",
                    type: "autocompleteMultiple",
                },
                often: {
                    systemName: "is_often",
                    type: "switch",
                },
                oiliness: {
                    systemName: "oiliness",
                    type: "autocompleteMultiple",
                },
                pack: {
                    systemName: "pack",
                    type: "autocompleteMultiple",
                },
                parentCategoryID: {
                    systemName: "parent_category_id",
                    type: "autocompleteMultiple",
                },
                pesticideCharacterAction: {
                    systemName: "pesticideCharacterAction",
                    type: "autocompleteMultiple",
                },
                pesticideEffect: {
                    systemName: "pesticideEffect",
                    type: "autocomplete",
                },
                pesticideType: {
                    systemName: "pesticideType",
                    type: "autocompleteMultiple",
                },
                plantDisease: {
                    systemName: "plantDisease",
                    type: "autocompleteMultiple",
                },
                prepareForm: {
                    systemName: "prepareForm",
                    type: "autocompleteMultiple",
                },
                product: {
                    systemName: "product",
                    type: "autocomplete",
                },
                productivity: {
                    systemName: "productivity",
                    type: "autocompleteMultiple",
                },
                productDiscount: {
                    systemName: "discount",
                    type: "switch",
                },
                productSystemName: {
                    systemName: "productSystemName",
                    type: "autocomplete",
                },
                purposeDrug: {
                    systemName: "purposeDrug",
                    type: "autocompleteMultiple",
                },
                region: {
                    systemName: "region",
                    type: "autocompleteMultiple",
                },
                recommendedZone: {
                    systemName: "recommendedZone",
                    type: "autocompleteMultiple",
                },
                ripenessGroup: {
                    systemName: "ripenessGroup",
                    type: "autocompleteMultiple",
                },
                rm: {
                    systemName: "rm",
                    type: "autocompleteMultiple",
                },
                seasonality: {
                    systemName: "seasonality",
                    type: "autocompleteMultiple",
                },
                seedType: {
                    systemName: "seedType",
                    type: "autocompleteMultiple",
                },
                seedWeight: {
                    systemName: "seedWeight",
                    type: "autocompleteMultiple",
                },
                selection: {
                    systemName: "selection",
                    type: "autocompleteMultiple",
                },
                seller: {
                    systemName: "seller",
                    type: "autocomplete",
                },
                soilComplexType: {
                    systemName: "soilComplexType",
                    type: "autocompleteMultiple",
                },
                soilMicroType: {
                    systemName: "soilMicroType",
                    type: "autocompleteMultiple",
                },
                soilEffect: {
                    systemName: "soilEffect",
                    type: "autocomplete",
                },
                soilForm: {
                    systemName: "soilForm",
                    type: "autocomplete",
                },
                soilType: {
                    systemName: "soilType",
                    type: "autocompleteMultiple",
                },
                spikeType: {
                    systemName: "spikeType",
                    type: "autocompleteMultiple",
                },
                stressEffect: {
                    systemName: "stressEffect",
                    type: "autocomplete",
                },
                vegetationPeriod: {
                    systemName: "vegetationPeriod",
                    type: "autocompleteMultiple",
                },
                vegetationTerm: {
                    systemName: "vegetationTerm",
                    type: "autocompleteMultiple",
                },
                visibility: {
                    systemName: "visibility",
                    type: "autocomplete",
                },
                volchok: {
                    systemName: "volchok",
                    type: "autocompleteMultiple",
                },
                wholesale: {
                    systemName: "wholesale",
                    type: "switch",
                },
                winterTolerance: {
                    systemName: "winterTolerance",
                    type: "autocompleteMultiple",
                },
                weeds: {
                    systemName: "weeds",
                    type: "autocompleteMultiple",
                },
            },
            attribute: {},
            category: {},
            region: {},
        },
        frontUrl: process.env.MIX_FRONT_URL,
        usersFilters: {
            id: {
                systemName: "id",
                type: "autocompleteMultiple",
            },
            createdAt: {
                systemName: "createdAt",
                type: "range",
            },
            email: {
                systemName: "email",
                type: "autocompleteMultiple",
            },
            name: {
                systemName: "name",
                type: "autocompleteMultiple",
            },
            phone: {
                systemName: "phone",
                type: "autocompleteMultiple",
            },
            search: {
                systemName: "search",
                type: "search",
            },
        },
        ordersFilters: {
            buyer: {
                systemName: "buyer_id",
                type: "autocompleteMultiple",
            },
            seller: {
                systemName: "seller_id",
                type: "autocompleteMultiple",
            },
            product: {
                systemName: "product_id",
                type: "autocompleteMultiple",
            },
            createdAt: {
                systemName: "createdAt",
                type: "range",
            },
            price: {
                systemName: "price",
                type: "range",
            },
            sum: {
                systemName: "sum",
                type: "range",
            },
            status: {
                systemName: "status",
                type: "autocomplete",
            },
        },
        language: {
            appLanguage: "ru",
        },
        mainMenu: [],
        selectedAttributesValues: [],
        selectedCategories: [],
        selectedUsers: [],
        selectedOrders: [],
        selectedProducts: [],
        updateAttributesFilters: false,
        updateAttributesTable: false,
        updateCategoriesFilters: false,
        updateCategoriesTable: false,
        user: {
            token: "",
            loggedIn: false,
            userName: "",
            email: "",
            role: {},
        },
    },
    getters: {
        access(state) {
            return state.access;
        },
        accessModal(state) {
            return state.access.showModal;
        },
        appLanguage(state) {
            return state.language.appLanguage;
        },
        currencies(state) {
            return state.currencies;
        },
        drawer(state) {
            return state.drawer;
        },
        existence(state) {
            return state.existence;
        },
        filtersGeneral(state) {
            return state.filters.general;
        },
        frontUrl(state) {
            return state.frontUrl;
        },
        mainMenu(state) {
            return state.mainMenu;
        },
        selectedAttributesValues(state) {
            return state.selectedAttributesValues;
        },
        selectedCategories(state) {
            return state.selectedCategories;
        },
        selectedProducts(state) {
            return state.selectedProducts;
        },
        token(state) {
            return state.user.token;
        },
        updateAttributesFilters(state) {
            return state.updateAttributesFilters;
        },
        updateAttributesTable(state) {
            return state.updateAttributesTable;
        },
        updateCategoriesTable(state) {
            return state.updateCategoriesTable;
        },
        user(state) {
            return state.user;
        },
        usersFilters(state) {
            return state.usersFilters;
        },
    },
    mutations: {
        setAccess(state, access) {
            state.access = access;
        },
        setAppToken(state, token) {
            state.user.token = token;
        },
        setDrawer(state, payload) {
            state.drawer = payload;
        },
        setMainMenu(state, menu) {
            state.mainMenu = menu;
        },
        setSelectedAttributesValues(state, items) {
            state.selectedAttributesValues = items;
        },
        setSelectedCategories(state, items) {
            state.selectedCategories = items;
        },
        setSelectedUsers(state, items) {
            state.selectedUsers = items;
        },
        setSelectedOrders(state, items) {
            state.selectedOrders = items;
        },
        setSelectedProducts(state, items) {
            state.selectedProducts = items;
        },
        setUpdateAttributesFilters(state, value) {
            state.updateAttributesTable = value;
        },
        setUpdateAttributesTable(state, value) {
            state.updateAttributesTable = value;
        },
        setUpdateCategoriesFilters(state, value) {
            state.updateCategoriesFilters = value;
        },
        setUpdateCategoriesTable(state, value) {
            state.updateCategoriesTable = value;
        },
        setUser(state, data) {
            state.user = data;
        },
    },
};
